import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Header from "../../Components/Header/Header";
import "./LandingPage.css";
import { RxDashboard } from "react-icons/rx";
import { LuTrophy } from "react-icons/lu";
import { BsGraphUp } from "react-icons/bs";
import { TbReportAnalytics, TbReport, TbLogout } from "react-icons/tb";
import { HiOutlineUserGroup } from "react-icons/hi";
import { AiOutlineHistory } from "react-icons/ai";
import { BiNews } from "react-icons/bi";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import { MdOutlineSupport } from "react-icons/md";
import { BiUser } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";
import NavPages from "../../NavPages";
import DepositNotifier from "../../Components/DepositNotifier/DepositNotifier";
import MobileTabBar from "../../Components/MobileTabBar/MobileTabBar";
import { useSelector, useDispatch } from "react-redux";
import { setSidebarDisplay } from "./../../Redux/SideDisplaySlice";
import { IoIosArrowUp } from "react-icons/io";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import { ApiPaths } from "../../Config/ApiPath";
import ScrollToTop from "../../Common/ScrollToTop";
import { BasicInfo, toastFailed, toastSuccess } from "../../Config/BasicInfo";
import { setUserPersonalInfo } from "../../Redux/ProfileDataSlice";
import useAxiosHelper from "../../Common/AxiosHelper";
import { RiFolderTransferLine } from "react-icons/ri";
import { setaccount } from "../../Redux/Accounts";
import { setDisConnectWallet } from "../../Redux/StatusState";
import { RiExchangeBoxLine } from "react-icons/ri";
import { RiFundsLine } from "react-icons/ri";
const LandingPage = () => {
  const sideDisplay = useSelector((state) => state.sideDisplay.value);
  const [alertmsg, setAlertmsg] = useState("-130px");
  const [partnerSideIcon, setPartnerSideIcon] = useState("180deg");
  const [partnerDropdown, setPartnerDropdown] = useState("0px");
  const [partnerDropdownVisi, setPartnerDropdownVisi] = useState("hidden");
  const [fundSideIcon, setFundSideIcon] = useState("180deg");
  const [fundDropdown, setFundDropdown] = useState("0px");
  const [fundDropdownVisi, setFundDropdownVisi] = useState("hidden");
  const [loading, setLoading] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const { AxiosPost, AxiosGet } = useAxiosHelper();
  const profileData = useSelector(
    (state) => state.profileData.userPersonalInfo
  );
  const [theme, setTheme] = useState("dark");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    fetchData();
    ScrollToTop();
  }, [location.pathname]);

  async function LogoutFunc() {
    try {
      const res = await AxiosPost(ApiPaths.logout);
      console.log("logout response", res);
      localStorage.clear();
      dispatch(setaccount(null));
      dispatch(setDisConnectWallet(true));
      window.location.reload();
    } catch (error) {
      toastFailed("Failed to logout");
    }
  }
  useEffect(() => {
    window.addEventListener("load", () => { });
  });
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  const handleDropdownToggle = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };
  async function fetchData() {
    try {
      const res1 = await AxiosGet(ApiPaths.getProfile);

      if (res1) dispatch(setUserPersonalInfo(res1));
    } catch (error) {
      BasicInfo.isDebug && console.log(error);
    }
  }
  function handleDropDown() {
    setFundDropdown("0px");
    setFundDropdownVisi("hidden");

    setPartnerSideIcon("180deg");
    setPartnerDropdown("0px");
    setPartnerDropdownVisi("hidden");
    if (width < 800) dispatch(setSidebarDisplay("none"));
  }
  function handleDrop() {
    // Reset partner dropdown states
    setPartnerSideIcon("180deg");
    setPartnerDropdown("0px");
    setPartnerDropdownVisi("hidden");

    // Reset fund dropdown states
    setFundSideIcon("180deg");
    setFundDropdown("0px");
    setFundDropdownVisi("hidden");

    if (width < 800) dispatch(setSidebarDisplay("none"));
    setConfirmLogout(true);
  }

  function handleSidebarLogout() {
    localStorage.clear();
    dispatch(setaccount(null));
    dispatch(setDisConnectWallet(true));
    if (width < 800) dispatch(setSidebarDisplay("none"));
    window.location.reload();
  }
  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );
    useEffect(() => {
      // Load theme preference from localStorage or a default value
      const savedTheme = localStorage.getItem("theme") || "dark";
      setTheme(savedTheme);
    }, []);
    useEffect(() => {
      // Save theme preference in localStorage
      localStorage.setItem("theme", theme);
    }, [theme]);
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    });
    return windowDimensions;
  }
  const { height, width } = useWindowDimensions();
  useEffect(() => {
    if (width > 800) {
      dispatch(setSidebarDisplay("block"));
    } else {
      dispatch(setSidebarDisplay("none"));
    }
  }, [width]);

  return (
    <>
      {confirmLogout ? (
        <div className="otpSection" style={{ zIndex: "999" }}>
          <div className="otpContainer">
            <h1>Logout</h1>
            <p>Are you sure you want to log out?</p>
            {
              <div>
                <button
                  className="btnSecondary"
                  onClick={() => setConfirmLogout(false)}
                >
                  No
                </button>
                <button className="btnPrimary" onClick={LogoutFunc}>
                  Yes
                </button>
              </div>
            }
          </div>
        </div>
      ) : null}
      <section className="landingPage landing-card">
        {/* <div className="landingBlur"> */}
        <div className="alertMsg" style={{ top: alertmsg }}>
          Link Copied!
        </div>
        <Container className="landingPageContainer">
          <section className="landingPageContent">
            {width <= 800 && sideDisplay === "block" && (
              <div
                className="sidebar-overlay"
                onClick={() => dispatch(setSidebarDisplay("none"))}
                aria-hidden="true"
              />
            )}
            <div
              className={`sidebar ${width <= 800 ? (sideDisplay === "block" ? "sidebar--open" : "sidebar--closed") : ""}`}
              style={width > 800 ? { display: sideDisplay } : undefined}
            >
              <div className="sidebar-header">
                <Link to="/dashboard" className="sidebar-logo">
                  <img
                    src={theme == "dark" ? BasicInfo.logo : BasicInfo.logo}
                    alt="Logo"
                  />
                </Link>
                <button
                  type="button"
                  className="sidebar-close"
                  onClick={() => dispatch(setSidebarDisplay("none"))}
                  aria-label="Close menu"
                >
                  <RxCross2 />
                </button>
              </div>
              <div className="sidebar-user">
                <div className="sidebar-user-avatar">
                  {(profileData?.name || "U").charAt(0).toUpperCase()}
                  <span
                    className={`sidebar-user-status ${profileData?.status == 0
                        ? "status-inactive"
                        : profileData?.email_verified === false
                          ? "status-pending"
                          : "status-active"
                      }`}
                    title={
                      profileData?.status == 0
                        ? "Inactive"
                        : profileData?.email_verified === false
                          ? "Pending verification"
                          : "Active"
                    }
                  />
                </div>
                <div className="sidebar-user-meta">
                  <span className="sidebar-user-name">{profileData?.name}</span>
                  <span className="sidebar-user-id">
                    @{profileData?.username}
                  </span>
                </div>
              </div>

              <nav id="sideItems" className="sidebar-nav">
                <span className="sidebar-section-label">Menu</span>

                <NavLink
                  to="/dashboard"
                  end
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                >
                  <div className="sideLink">
                    <i>
                      <RxDashboard />
                    </i>
                    <h5>Dashboard</h5>
                  </div>
                </NavLink>

                <NavLink
                  to="profile"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={() =>
                    width < 800 ? dispatch(setSidebarDisplay("none")) : ""
                  }
                >
                  <div className="sideLink">
                    <i>
                      <BiUser />
                    </i>
                    <h5>Profile</h5>
                  </div>
                </NavLink>
                <span className="sidebar-section-label">Investment</span>
                <NavLink
                  to="package"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                >
                  <div className="sideLink">
                    <i>
                      <BsGraphUp />
                    </i>
                    <h5>Prime Package</h5>
                  </div>
                </NavLink>



                <NavLink
                  to="deposit"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                >
                  <div className="sideLink">
                    <i>
                      <RiFundsLine />
                    </i>
                    <h5>Add Fund</h5>
                  </div>
                </NavLink>

                <NavLink
                  to="fund"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                >
                  <div className="sideLink">
                    <i>
                      <RiExchangeBoxLine />
                    </i>
                    <h5>Fund Convert</h5>
                  </div>
                </NavLink>
                <NavLink
                  to="ranks"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                >
                  <div className="sideLink">
                    <i>
                      <LuTrophy />
                    </i>
                    <h5>Ranks</h5>
                  </div>
                </NavLink>
                <span className="sidebar-section-label">Network &amp; Income</span>
                <div id="partnershipSideFullDiv">
                  <div
                    className="sideLink"
                    onClick={() => {
                      setPartnerSideIcon((prev) =>
                        prev === "180deg" ? "0deg" : "180deg"
                      );
                      setPartnerDropdown((prev) =>
                        prev === "0px" ? "88px" : "0px"
                      );
                      setPartnerDropdownVisi((prev) =>
                        prev === "hidden" ? "visible" : "hidden"
                      );

                      // Ensure the fund dropdown is closed when partner dropdown is toggled
                      setFundSideIcon("180deg");
                      setFundDropdown("0px");
                      setFundDropdownVisi("hidden");
                    }}
                  >
                    <i>
                      <HiOutlineUserGroup />
                    </i>
                    <div id="partnershipSideDiv">
                      <h5>Team </h5>
                      <i style={{ transform: `rotate(${partnerSideIcon})` }}>
                        <IoIosArrowUp />
                      </i>
                    </div>
                  </div>
                  <div
                    id="sideDropdown"
                    style={{
                      height: partnerDropdown,
                      visibility: partnerDropdownVisi,
                    }}
                  >
                    <NavLink
                      to="direct_team"
                      exact={true}
                      activeClassName="activeTab"
                      onClick={() =>
                        width < 800 ? dispatch(setSidebarDisplay("none")) : ""
                      }
                      disabled={profileData?.profile_edit_status == 0}
                    >
                      <p className="dropdownData">Team Members</p>
                    </NavLink>
                    <NavLink
                      to="genealogy"
                      exact={true}
                      activeClassName="activeTab"
                      onClick={() =>
                        width < 800 ? dispatch(setSidebarDisplay("none")) : ""
                      }
                      disabled={profileData?.profile_edit_status == 0}
                    >
                      <p className="dropdownData">Genealogy Tree</p>
                    </NavLink>
                  </div>
                </div>
                <NavLink
                  to="incomes"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                  disabled={profileData?.profile_edit_status == 0}
                >
                  <div className="sideLink">
                    <i>
                      <TbReportAnalytics />
                    </i>
                    <h5>Incomes</h5>
                  </div>
                </NavLink>


                <NavLink
                  to="transaction_history"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                  disabled={profileData?.profile_edit_status == 0}
                >
                  <div className="sideLink">
                    <i>
                      <TbReportAnalytics />
                    </i>
                    <h5>Transaction History</h5>
                  </div>
                </NavLink>
                <NavLink
                  to="claim"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={() =>
                    width < 800 ? dispatch(setSidebarDisplay("none")) : ""
                  }
                  disabled={profileData?.profile_edit_status == 0}
                >
                  <div className="sideLink">
                    <i>
                      <AiOutlineHistory />
                    </i>
                    <h5>Withdrawal</h5>
                  </div>
                </NavLink>
                <span className="sidebar-section-label">More</span>
                <NavLink
                  to="support"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={handleDropDown}
                  disabled={profileData?.profile_edit_status == 0}
                >
                  <div className="sideLink">
                    <i>
                      <MdOutlineSupport />
                    </i>
                    <h5>Support</h5>
                  </div>
                </NavLink>

                <NavLink
                  to="news"
                  exact={true}
                  activeClassName="activeTab"
                  onClick={() =>
                    width < 800 ? dispatch(setSidebarDisplay("none")) : ""
                  }
                  disabled={profileData?.profile_edit_status == 0}
                >
                  <div className="sideLink">
                    <i>
                      <BiNews />
                    </i>
                    <h5>News & Updates</h5>
                  </div>
                </NavLink>

                <button
                  type="button"
                  className="sideLink sidebar-logout-btn"
                  onClick={handleSidebarLogout}
                >
                  <i>
                    <TbLogout />
                  </i>
                  <h5>Logout</h5>
                </button>
              </nav>
            </div>
            <div className="dashboardPages">
              <Header
                link={
                  window.location.origin +
                  "/register?ref=" +
                  profileData?.username
                }
                username={profileData?.username}
                name={profileData?.name}
                theme={theme}
                status={profileData?.status}
                setTheme={setTheme}
              />

              <NavPages />
              <DepositNotifier />
              <MobileTabBar />
            </div>
          </section>
          <Footer />
        </Container>
        {/* <div className="cardShadowLanding"></div>
        <div className="cardShadowLandingLeft"></div> */}
        {/* </div> */}
      </section>
    </>
  );
};

export default LandingPage;
